import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Typography, Button } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  icon: {
    color: theme.palette.error.main,
  },
  message: {
    flex: '1 1 auto',
    minWidth: 200,
  },
}));

const AnalyticsError = props => {
  const { message, onRetry } = props;
  const classes = useStyles();

  return (
    <Card>
      <CardContent className={classes.content}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography variant="body1" className={classes.message}>{message}</Typography>
        {onRetry && (
          <Button color="primary" variant="outlined" onClick={onRetry}>Retry</Button>
        )}
      </CardContent>
    </Card>
  );
};

AnalyticsError.propTypes = {
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func,
};

export default AnalyticsError;
